
export interface IRemoteStreamContent {
  fileName?: string;
  contentType?: string;
  contentLength?: number;
}
